const TEMPLATE_REGEX_SOURCE = '{{([^}]+)}}'
// Capturing group is intentional: String.split() with a capturing group preserves
// the delimiters in the result array, allowing template parts to be reconstructed.
const TEMPLATE_SPLIT_REGEX = /({{[^}]+}})/
const TEMPLATE_PART_REGEX = /^{{([^}]+)}}$/

const templateRegex = () => new RegExp(TEMPLATE_REGEX_SOURCE, 'g')

export const splitTemplateParts = (template) => template ? template.split(TEMPLATE_SPLIT_REGEX) : []

export const matchTemplatePart = (part) => {
    const m = part.match(TEMPLATE_PART_REGEX)
    return m ? m[1].trim() : null
}

export const parseTemplateVariables = (str) => {
    if (!str) return []
    const seen = new Set()
    const variables = []
    let match
    const regex = templateRegex()
    while ((match = regex.exec(str)) !== null) {
        const name = match[1].trim()
        if (!seen.has(name)) {
            seen.add(name)
            variables.push(name)
        }
    }
    return variables
}

export const resolveTemplate = (template, values = {}) => {
    if (!template) return template
    return template.replace(templateRegex(), (full, name) => {
        const trimmed = name.trim()
        const val = values[trimmed]?.trim()
        return val ? val : full
    })
}

export const templateHasUnresolvedVariables = (template, values = {}) => {
    if (!template) return false
    const regex = templateRegex()
    let match
    while ((match = regex.exec(template)) !== null) {
        const name = match[1].trim()
        if (!values[name]?.trim()) return true
    }
    return false
}
